import React, { ChangeEventHandler, FocusEventHandler, forwardRef, ReactNode, Ref } from 'react'

interface ITextProps {
  children: ReactNode
  id: string
  placeholder?: string
  isReadOnly?: boolean
  maxLength?: number
  onChange?: ChangeEventHandler<HTMLInputElement>
  onFocus?: FocusEventHandler<HTMLInputElement>
  onBlur?: FocusEventHandler<HTMLInputElement>
  isDisabled?: boolean
  type?: string
  value?: string
}

export const Text = forwardRef((props: ITextProps, ref: Ref<HTMLInputElement>) => {
  const inputType = props.type ? props.type : 'text'

  return (
    <>
      <label htmlFor={props.id} className="ipt-box__lb">
        {props.children}
      </label>
      <input
        type={inputType}
        id={props.id}
        className="ipt-box__ipt"
        placeholder={props.placeholder}
        readOnly={props.isReadOnly}
        maxLength={props.maxLength}
        onChange={props.onChange}
        onFocus={props.onFocus}
        onBlur={props.onBlur}
        ref={ref}
        value={props.value}
        disabled={props.isDisabled}
      />
    </>
  )
})
